import { SceneSet } from '@bighealth/types';

export const getSessionProgressPercent = (
  sceneSet: SceneSet
): number | undefined => sceneSet?.session_progress_percent;
